import { WorkspaceSwitcherItem } from "@components/general/NavigationDropdown/WorkspaceSwitcherItem";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useSwitchToPersonalView } from "@hooks/useSwitchToPersonalView";
import { useOrganizations } from "@api/organization.api";
import { Dropdown } from "react-bootstrap";
import { OrganizationSwitcher } from "@components/general/NavigationDropdown/OrganizationSwitcher";
import { FC } from "react";
import { useOrganizationWorkspaces } from "@hooks/useOrganizationWorkspaces";

export const DefaultNavigationDropdownBody: FC = () => {
    const { personalView: personalViewEnabled } = useTypedFlags();
    const goToPersonalView = useSwitchToPersonalView();

    const { data: userWorkspaces, isLoading: isLoadingWorkspaces } =
        useOrganizationWorkspaces();
    const { data: userOrganizations } = useOrganizations();

    const hasMultipleWorkspaces = (userWorkspaces?.data?.length ?? 0) > 1;
    const hasAccessToAnyOrganization = (userOrganizations?.length ?? 0) > 0;
    const showPersonalViewItem =
        personalViewEnabled && !hasAccessToAnyOrganization;

    return (
        <>
            {hasMultipleWorkspaces && (
                <>
                    <WorkspaceSwitcherItem disabled={isLoadingWorkspaces} />
                    {showPersonalViewItem && (
                        <Dropdown.Item onClick={goToPersonalView}>
                            View all workspaces
                        </Dropdown.Item>
                    )}
                    <Dropdown.Divider />
                </>
            )}

            {hasAccessToAnyOrganization && (
                <>
                    <OrganizationSwitcher />
                    <Dropdown.Divider />
                </>
            )}
        </>
    );
};
